export enum DrawerTabs {
  Details = "Details",
  Logs = "Logs",
  Diff = "Diff",
}
